import styled, { css } from 'styled-components';
import Icon from '../../_shared/components/Icon';
import Button from '../../_shared/components/Button';
import isOmpPlatform from '../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

export const ModalOuterBoxContainer = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  margin: 0 auto;
  width: 888px;
  font-size: ${({ theme }) => theme.FONT_SIZES.XXLARGE};
  line-height: 53px;
  position: relative;
`;

export const BoldDescriptionText = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 24px;
  margin-top: 4px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const ModalOuterBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 36px 30px 36px;
  gap: 30px;
  width: 888px;
  background: ${({ theme }) => theme.COLORS.BASE};
  border: ${({ theme }) =>
    isOmp
      ? `1px solid ${theme.COLORS.LIGHT_GREY}`
      : `1px solid  ${theme.COLORS.NEUTRAL_110}`};
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_110};
  border-radius: 3px;
  margin-top: 20px;
  box-shadow: ${isOmp ? 'none' : '0px 1px 6px rgba(0, 0, 0, 0.2)'};
`;

export const ModalBoxContentWrapper = styled.div``;

export const ModalHeader = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  font-weight: ${({ theme }) => theme.FONT_WEIGHTS.SEMI_BOLD};
  line-height: 24px;
  letter-spacing: 0.25px;
`;

export const StyledSubTitle = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  line-height: ${isOmp ? '32px' : '20px'};
  margin-bottom: ${isOmp ? '30px' : '5px'};
`;

export const FieldGroup = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: 20px;
  margin-top: 30px;
  margin-bottom: 5px;
`;

export const FieldName = styled.label`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: 20px;
  margin: 10px 0;
  font-family: ${({ theme }) =>
    isOmp ? theme.FONT.SEMI_BOLD : theme.FONT.REGULAR};
  color: ${({ theme }) =>
    isOmp ? theme.COLORS.BASE_INVERTED : theme.COLORS.NEUTRAL_30};
`;

const FieldInputVariants = {
  salespersonPhone: css`
    border: ${({ isPhoneInputError, theme }) =>
      isPhoneInputError
        ? `1px solid ${theme.COLORS.RED}}`
        : `1px solid ${theme.COLORS.NEUTRAL_20}`};
  `,
  salespersonEmail: css`
    border: ${({ isEmailInputError, theme }) =>
      isEmailInputError
        ? `1px solid ${theme.COLORS.RED}}`
        : `1px solid ${theme.COLORS.NEUTRAL_20}`};
  `,
  salespersonName: css``,
  dealershipWebsite: css``,
  modal: css``
};

export const FieldInput = styled.input`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: 21px;
  display: block;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  ${props => FieldInputVariants[props.variant]};
  width: 100%;
  height: 40px;
  margin-top: 5px;
  border-radius: 3px;
  padding: 7px;
  ::placeholder {
    color: ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_20 : theme.COLORS.NEUTRAL_30};
  }
`;

export const ModalFieldTextArea = styled.textarea`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  width: 100%;
  margin-top: 5px;
  line-height: 21px;
  display: block;
  border-radius: 3px;
  padding: 7px;
  resize: none;
  ::placeholder {
    color: ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_20 : theme.COLORS.NEUTRAL_30};
  }
`;

const FieldDescriptionVariants = {
  placeholder: css`
    color: ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_20 : theme.COLORS.NEUTRAL_30};
    font-style: italic;
  `,
  value: css``
};

export const FieldDescription = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: 20px;
  letter-spacing: 0.25px;
  max-width: 79%;

  ${props => FieldDescriptionVariants[props.variant]};
  ${isOmp &&
    css`
      width: 606px;
    `}
`;

export const FieldDealerName = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) =>
    isOmp ? theme.FONT_SIZES.MEDIUM : theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  line-height: 40px;
  letter-spacing: 0.25px;
  ${isOmp &&
    css`
      width: 800px;
    `}
`;

export const FieldDisclaimer = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  line-height: 16px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin-top: 4px;
  ${isOmp &&
    css`
      font-family: ${({ theme }) => theme.FONT.REGULAR};
    `}
`;

export const ModalTextFieldGroup = styled.div`
  width: 100%;
`;

export const StyledLogoContainer = styled.div`
  border: 1.5px solid ${({ theme }) => theme.COLORS.NEUTRAL_120};
  border-radius: 3px;
  width: 136px;
  height: 101px;
  display: flex;
  align-items: center;
  margin-left: -24px;
`;

export const StyledLogoPreview = styled.img`
  width: 133px;
  height: 56px;
  object-fit: contain;
`;

export const StyledLogoGroup = styled.div`
  display: flex;
  margin-top: 30px;
`;

StyledLogoGroup.LogoInputLabel = styled.label`
  display: block;
  border: 1.5px solid ${({ theme }) => theme.COLORS.NEUTRAL_120};
  border-radius: 3px;
  width: 136px;
  height: 101px;
`;

StyledLogoGroup.ModalLogoInputLabel = styled.label`
  display: block;
  border: 1.5px solid ${({ theme }) => theme.COLORS.NEUTRAL_120};
  border-radius: 3px;
  width: 200px;
  height: 101px;
`;

StyledLogoGroup.LogoInput = styled.input`
  display: none;
`;

StyledLogoGroup.StyledBrowseImage = styled.img`
  display: block;
  margin: 25px auto;
  cursor: pointer;
`;

StyledLogoGroup.StyledAddIcon = styled(Icon).attrs({
  icon: 'TR5-Add_Photo'
})`
  position: relative;
  bottom: ${isOmp ? '30px' : '46px'};
  left: 104px;
  cursor: pointer;
  path {
    fill: ${({ theme }) => (isOmp ? theme.COLORS.TERTIARY : 'none')};
    stroke-width: 1.5px;
    stroke: ${({ theme }) =>
      isOmp ? theme.COLORS.BASE : theme.COLORS.DARKER_GREY};
  }
`;
StyledLogoGroup.StyledRemoveIcon = styled(Icon).attrs({
  icon: 'TR5-Remove'
})`
  position: relative;
  left: 108px;
  top: 4px;
  cursor: pointer;
  position: relative;
  z-index: 2;
`;

export const StyledDivider = styled.div`
  margin: 30px auto;
  border-top: 0.5px solid ${({ theme }) => theme.COLORS.NEUTRAL_100};
  width: 824px;
`;

export const StyledNoteGroup = styled.div`
  margin-left: 16px;
`;

StyledNoteGroup.StyledNote = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: 21px;
  width: ${isOmp ? 'auto' : '278px'};
  &:nth-child(2) {
    margin-top: 18px;
  }
`;

const FormContainerVariants = {
  tiah: css`
    display: block;
  `,
  retailVdp: css`
    display: grid;
    grid-template-columns: 216px 360px 216px;
    grid-gap: 0px 18px;
  `,
  modal: css``
};

export const FormContainer = styled.div`
  ${props => FormContainerVariants[props.variant]};
`;

export const TitleText = styled.div`
  font-family: ${({ theme }) =>
    isOmp ? theme.FONT.POPPINS : theme.FONT.REGULAR};
  font-size: ${({ theme }) =>
    isOmp ? theme.FONT_SIZES.XLARGE : theme.FONT_SIZES.XXLARGE};
  font-weight: ${({ theme }) => (isOmp ? '500' : theme.FONT_WEIGHTS.REGULAR)};
  color: ${({ theme }) =>
    isOmp ? theme.COLORS.DARK_BLUE_2 : theme.COLORS.BLACK};
  line-height: 32px;
  margin-top: ${isOmp ? 'auto' : '32px'};
`;

export const EditInfoButton = styled(Button)`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-weight: ${({ theme }) => theme.FONT_WEIGHTS.REGULAR};
  border: none;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  position: absolute;
  margin-right: 48px;
  bottom: -6px;
  right: 30px;
  text-align: right;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const StyledWarning = styled.div`
  color: ${({ theme }) => theme.COLORS.DARKER_GREY};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 32px;
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  margin-top: 10px;
`;

StyledWarning.Message = styled.div`
  color: ${({ theme }) => theme.COLORS.DARKER_GREY};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 24px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  margin-top: 5px;
  margin-bottom: 32px;
  width: 800px;
`;
